import React from 'react';
import { Modal, Button } from 'antd';





function FaqModal({open, close}) {


  return (
      <>
        <Modal
            title="Что умеет AI-ассистент (далее - бот)?"
            open={open}
            // onOk={handleOk}
            onCancel={close}
            width={'80%'}
            footer={[
              // <Button key="back" type="primary" onClick={close}>
              //   Закрыть
              // </Button>
            ]}

        >

            <p style={{
                marginBottom: 0
            }}>
                Бот обрабатывает данные по продажам, закупкам за 2023-24 гг,.
                <br/>
                Он может:
            </p>
            <ul style={{
                marginTop: '5px'
            }}>
                <li>
                    Считать выручку и количество продаж за период;
                </li>
                <li>
                    Определять ТОП-товары;
                </li>
                <li>
                    Показывать динамику в табличном формате по дням, неделям, месяцам;
                </li>
                <li>
                    Сравнивать периоды и делать аналитику по магазинам, категориям товаров и отдельным товарам;
                </li>
                <li>
                    Работает через понятные текстовые запросы: «Сколько продано воды Samal в марте 2023?», «Какая была выручка в июне 2024?» и т.д.
                </li>
            </ul>
            <h3 style={{marginBottom:0}}>
                Что бот пока не умеет?
            </h3>
            <p style={{marginBottom:0, marginTop: 0}}>
                Некоторые функции пока недоступны, поскольку не хватает части данных:
            </p>
            <ul style={{
                marginTop: '5px'
            }}>
                <li>
                    Нет прогноза продаж и анализа out-of-stock: нет информации о внутренних перемещениях в 2023-24гг.
                </li>
                <li>
                    Нет ABC/XYZ-анализа и расчета маржинальности: отсутствует логика расчета маржинальности от бухгалтерии.
                </li>
                <li>
                    Нет оценки чистой прибыли и анализа влияния внешних факторов (погода, праздники): требуется дополнительная структура данных.
                </li>
            </ul>
        </Modal>
      </>
  );
}

export default FaqModal;
